import { Mail, Phone, MapPin, Clock } from 'lucide-react'
import logoImage from '@/assets/logos/logo.png'

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 relative z-50">
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
              <img 
                src={logoImage} 
                alt="TAKT Construction Services" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-white font-bold text-xl">TAKT Construction</span>
            </div>
            
            <div className="flex flex-col space-y-2">
              <a 
                href="/join-our-team" 
                className="text-gray-400 hover:text-white transition-colors text-sm py-2 px-4 bg-gray-800 hover:bg-gray-700 rounded-lg text-center"
              >
                Join Our Team
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg border-b border-gray-700 pb-2">Our Services</h3>
            <ul className="space-y-3 text-sm">
              <li><a href="/services?category=commercial" className="hover:text-white transition-colors block py-1">Commercial</a></li>
              <li><a href="/services?category=residential" className="hover:text-white transition-colors block py-1">Residential</a></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg border-b border-gray-700 pb-2">Quick Links</h3>
            <ul className="space-y-3 text-sm">
              <li><a href="/" className="hover:text-white transition-colors block py-1">Home</a></li>
              <li><a href="/services" className="hover:text-white transition-colors block py-1">Services</a></li>
              <li><a href="/work" className="hover:text-white transition-colors block py-1">Our Work</a></li>
              <li><a href="/about" className="hover:text-white transition-colors block py-1">About</a></li>
              <li><a href="/contact" className="hover:text-white transition-colors block py-1">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg border-b border-gray-700 pb-2">Contact Info</h3>
            <div className="space-y-4 text-sm">
              <div className="flex items-center space-x-3">
                <Phone className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <a href="tel:+16048428258" className="hover:text-white transition-colors">
                  604-842-8258
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <a href="mailto:support@taktcon.com" className="hover:text-white transition-colors">
                  support@taktcon.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <span>Vancouver, BC</span>
              </div>
              <div className="flex items-center space-x-3">
                <Clock className="h-4 w-4 text-blue-400 flex-shrink-0" />
                <span>Mon-Fri: 8AM-6PM</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-400">
              © 2024 TAKT Construction Services Ltd. All rights reserved.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="/terms-of-service" className="hover:text-white transition-colors">Terms of Service</a>
              <a href="/sitemap" className="hover:text-white transition-colors">Sitemap</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
} 